(() => {
	angular.module('main').directive('workflowList', workflowList);

	workflowList.$inject = [
		'workflowDragNDropService',
		'$rootScope',
		'stringModifierService',
		'timeConverter',
		'newWorkflowService',
		'messageService',
		'customizeLabelsService'
	];

	function workflowList(
		workflowDragNDropService,
		$rootScope,
		stringModifierService,
		timeConverter,
		newWorkflowService,
		messageService,
		customizeLabelsService
	) {
		return {
			restrict: 'E',
			scope: {
				now: '<',
				allTasks: '=',
				changeTaskState: '&',
				changeToLeadOrJob: '&',
				correctSortedTasksArray: '<correctOrder',
				items: '=',
				itemId: '@',
				label: '@',
				job: '=',
				leadId: '=',
				jobToEdit: '=',
				workflowClass: '@',
				renewWorkflow: '&',
				showWarning: '&',
				archived: '=',
				showModal: '&',
				mainShootLabelName: '=',
				extraShootLabelName: '='
			},
			template: ` 
                <div class="workflow-list">
             
                    <div class="workflow-list-title {{workflowClass}}">
                        <span ng-show="items.length > 2">{{label}}</span>
                        <span ng-show="items.length === 2" style="width: 95px">{{label}}</span>
                    </div>
                    
                    <ul class="list list-unstyled list-{{workflowClass}}"  
                        dnd-list="items"
                        dnd-dragover="onDragOver(type)">
                       
                        <li class="workflow-item task-{{task.number}}"
                            dnd-draggable="task"   
                            dnd-dragend="onDragend(task, event)" 
                            dnd-moved="items.splice($index, 1)"
                            dnd-type="'{{task.calendarEventType || 'noEvents'}}'"
                            dnd-disable-if="(task.defaultTask && task.calendarEventType !== 'MAIN_SHOOT') || !$root.dnd.canMove || archived "
                            dnd-effect-allowed="move"
                            ng-repeat="task in items"
                            ng-class="{'pointer':!task.defaultTask, 'task-completed': task.completed || task.disabledAutomation, 'task-inactive' : task.disabled}">
                        
                            <div class="flex-row workflow-item__content" 
                                ng-class="{'withLabel': isLabelShown('hasAnyLabel', task), 
                                'default-task': (task.defaultTask && task.calendarEventType !== 'MAIN_SHOOT')}"
                                dnd-nodrag >
                              
                               <div class="checkbox-squared" ng-if="task.name !=='Job accepted' || !task.defaultTask">
                                    <input type="checkbox"
                                           id="{{itemId}}-{{$index}}"
                                           name="check"
                                           ng-model="task.completed" 
                                           ng-click="(task.disabledAutomation && task.completed) ? showWarningModal(task) : showSendModal(task)"
                                           ng-disabled="!$root.dnd.canMove || task.disabled || archived"/>
                                    <label for="{{itemId}}-{{$index}}"></label>
                               </div>
                               <div class="checkbox-squared" ng-if="task.name ==='Job accepted' && task.defaultTask">
                                    <input type="checkbox"
                                           id="{{itemId}}-{{$index}}"
                                           name="check"
                                           ng-model="task.completed" ng-click="changeToLeadOrJob({task : task})"
                                           ng-disabled="!$root.dnd.canMove || task.disabled || archived"/>
                                    <label for="{{itemId}}-{{$index}}"></label>
                               </div>
                               
                                 <div class="flex-row flex-wrap-md flex-just-space flex-align-center flex-grow-1">
                                
                                    <div class="workflow-item-description flex-grow-1">
                                 
                                        <div class="workflow-item-name text-break" ng-show="task.calendarEventType === 'MAIN_SHOOT'">{{' ' + job.name}}</div>
                                         <div class="workflow-item-name text-break" ng-show="task.calendarEventType !== 'MAIN_SHOOT'">{{' ' + task.name}}</div>
                                        <div class="workflow-item-data flex-row flex-wrap" ng-init="labelColor = task.disabledAutomation ? 'task.type' : 'label-danger-bright label-danger-bright--always'">
                                            <sn-label ng-if="::isLabelShown('jobAccepted-task', task)" class="{{task.completed ? 'job-accepted-check' : 'job-accepted-info'}} flex-basis-full" color="{{(task.completed || task.disabled) ? 'label-danger-bright': 'label-jobAccept'}}" 
                                            text="This checks automatically when a quote is accepted OR a contract is signed OR an invoice is paid. Once checked this lead becomes a job.">
                                            </sn-label>
                                            
                                            <p ng-if="::isLabelShown('hasLocation', task)" class="job-accepted-info-text flex-basis-full text-break">
                                                Location: {{task.location}}
                                            </p>
                           
                                            <sn-label ng-if="::isLabelShown('main-shoot', task)" text="{{mainShootLabelName}}" color="label-success"></sn-label>
                                            <sn-label ng-if="::isLabelShown('extra-shoot', task)" text="{{extraShootLabelName}}" color="label-success"></sn-label>
                                            <sn-label ng-if="::isLabelShown('appointment', task)" text="Appointment" color="{{task.type}}"></sn-label>
                                            <sn-label ng-if="::isLabelShown('action-email', task)" text="Send email" color="{{task.type}}"></sn-label>
                                            <sn-label ng-if="::isLabelShown('action-autoEmail', task)" text="Auto send email" color="{{task.type}}"></sn-label>
                                            <sn-label ng-if="::isLabelShown('action-contract', task)" text="Auto send contract" color="{{task.type}}"></sn-label>
                                            <sn-label ng-if="::isLabelShown('action-questionnaire', task)" text="Auto send questionnaire" color="{{task.type}}"></sn-label>
                                   
                                            <sn-label ng-if="task.number === 0" color="{{task.startDate ? 'label-success' : 'label-danger-bright'}}">
                                                <i class="fa fa-clock-o"></i>
                                                <span>{{task.taskDueDefault| timeFilter:'long'}}</span> 
                                            </sn-label>   
                                            <sn-label ng-if="::isLabelShown('any-shoot', task)" color="{{task.startDate ? 'label-success' : 'label-danger-bright'}}">
                                                <i class="fa fa-clock-o" ng-if="task.startDate"></i>
                                                <span ng-if="::!isLabelShown('hasType', task)">{{task.taskDueDefault| timeFilter:'long'}}</span>
                                                <main-shoot-date start-date="task.startDate" finish-date="task.endDate"></main-shoot-date>
                                            </sn-label>
                                            <sn-label ng-if="::isLabelShown('appointment', task)" color="{{task.startDate ? task.type : 'label-danger-bright'}}">
                                                <i class="fa fa-clock-o" ng-if="task.startDate"></i>
                                                <span ng-if="::!isLabelShown('hasType', task)">{{task.taskViewDue}}</span>
                                                <full-date-time start-date="task.startDate" start-time="task.startTime" finish-date="task.endDate" finish-time="task.endTime"></full-date-time>
                                            </sn-label>
                                            <sn-label ng-if="::isLabelShown('hasDue', task) && task.calendarEvent" text="{{task.taskViewDue}}" color="{{task.type}}"
                                                      ng-class="{labelColor: isLabelShown('isInactive', task, job.startDate, allTasks)}">
                                                  <i class="fa fa-clock-o"></i> 
                                            </sn-label>
                                            <sn-label ng-if="isJobActive(task) && !archived" text="{{trueDate | timeFilter: 'long'}}" 
                                                      color="{{::isLabelShown('isInactive', task, job.startDate, allTasks) ? labelColor : task.type}}">
                                                  <i class="fa fa-clock-o"></i> 
                                            </sn-label>
                                            <sn-label ng-if="::isLabelShown('hasOverdue', task) && !archived && task.hasDue !==false" text="{{task.overdueDays}}" color="label-danger-bright"></sn-label>  
                                            <sn-label ng-if="::isLabelShown('isInactive', task, job.startDate, allTasks) && !archived" text="Will not auto send"
                                              color="{{labelColor}}"></sn-label>
                                        </div>
                                    </div>
                                
                                    <workflow-options class="flex-item-width-full-md flex-just-center"
                                        ng-show="!task.defaultTask" 
                                        task="task"
                                        task-list="allTasks"
                                    ></workflow-options>
                                   
                                    <div class="flex-row flex-basis-xs flex-just-center">
                                        <btn-edit sn-text="Edit"
                                         class="m-5"
                                              ng-if="task.calendarEventType === 'MAIN_SHOOT' && leadId"
                                              ng-click="showEditLeadModal(jobToEdit)"
                                              ng-disabled="button_disable"
                                        ></btn-edit>
                                        
                                               <btn-edit sn-text="Edit job"
                                              class="m-5"
                                              ng-if="task.calendarEventType === 'MAIN_SHOOT' && !leadId"
                                              ng-click="showEditJobModal(jobToEdit)"
                                              ng-disabled="button_disable"
                                        ></btn-edit>  
                                       
                                    </div>
                           
                         
                                 </div>
                                 
                                 <div ng-class="{'dnd-icon' : (!task.defaultTask || task.calendarEventType === 'MAIN_SHOOT') , 'noEvents' : !$root.dnd.canMove}" 
                                      dnd-handle
                                  ></div>
                                  
                            </div>
                          
                        </li>
                    </ul>  
                   
                </div>
            `,

			replace: true,
			transclude: true,
			link(scope) {
				const defaultWorkflow = {
					id: '',
					name: 'Default'
				};

				$rootScope.dnd = {
					canMove: true
				};

				let lastCorrectOrder, startTasklistLength, correctTasksOrder;

				scope.isLabelShown = newWorkflowService.isLabelShown;

				const stopEvent = event => {
					event.stopImmediatePropagation();
					return false;
				};

				const revertChanges = () => {
					lastCorrectOrder = scope.correctSortedTasksArray
						? angular.copy(scope.correctSortedTasksArray)
						: angular.copy(scope.allTasks);
					scope.allTasks = angular.copy(lastCorrectOrder);
					$rootScope.dnd.canMove = true;
				};

				const setCorrectTasksOrder = () => {
					const isEqualNumbers = workflowDragNDropService.checkForEqualNumbers(
						scope.allTasks
					);
					const isTasksCountChanged =
						startTasklistLength !== scope.allTasks.length;
					const isWrongTasksOrder = isEqualNumbers || isTasksCountChanged;

					const tasks2Check = isWrongTasksOrder
						? lastCorrectOrder
						: scope.allTasks;

					correctTasksOrder = workflowDragNDropService.keepDefaultTasksInPlace(
						tasks2Check
					);
				};

				const dropCallback = draggedTask => {
					if (scope.archived) {
						messageService.showToaster('e_5', 'lead');
					}

					if ($rootScope.dnd.canMove) {
						return false;
					}

					const renewedList = workflowDragNDropService.saveNewTasksOrder(
						draggedTask,
						correctTasksOrder
					);

					if (renewedList) {
						renewedList.subscribe(result => {
							if (result && result.tasks) {
								scope.renewWorkflow({ tasks: result.tasks });
								$rootScope.dnd.canMove = true;
							} else {
								revertChanges();
							}
						}, revertChanges);
					} else {
						revertChanges();
					}
				};
				scope.onDragOver = type => {
					if (type && type.toUpperCase() === 'MAIN_SHOOT') {
						$('.dndPlaceholder').addClass('mainShootOver');
					} else {
						$('.dndPlaceholder').removeClass('mainShootOver');
					}
					return true;
				};

				scope.onDragStart = (task, event) => {
					if (!$rootScope.dnd.canMove) {
						return stopEvent(event);
					}

					lastCorrectOrder = scope.correctSortedTasksArray
						? angular.copy(scope.correctSortedTasksArray)
						: angular.copy(scope.allTasks);
					startTasklistLength = lastCorrectOrder.length;
					setCorrectTasksOrder();

					$rootScope.dnd.canMove = false;
					return task;
				};

				scope.onDragend = (draggedTask, event) => {
					event.stopImmediatePropagation();
					$rootScope.dnd.canMove = false;

					lastCorrectOrder = scope.correctSortedTasksArray
						? angular.copy(scope.correctSortedTasksArray)
						: angular.copy(scope.allTasks);
					startTasklistLength = lastCorrectOrder.length;

					setCorrectTasksOrder();
					scope.allTasks = angular.copy(correctTasksOrder);
					dropCallback(draggedTask);
				};

				scope.showWarningModal = function(task) {
					task.disabled = true;
					scope.showWarning({ task });
				};

				scope.showSendModal = function(task) {
					task.disabled = true;
					if (!task.completed || task.action === null) {
						scope.changeTaskState({ task });
					} else {
						scope.showModal({ task });
					}
				};

				scope.showEditJobModal = jobToEdit => {
					jobToEdit.workflow.name = stringModifierService.addSelectedText(
						jobToEdit.workflow.name
					);
					const isWorkflowSaved = jobToEdit.workflowNames.find(
						workflow => workflow.id === jobToEdit.workflow.id
					);
					if (jobToEdit.workflowNames && !isWorkflowSaved) {
						jobToEdit.workflowNames.push(jobToEdit.workflow);
					}
					$('#newJob').modal('show');

					scope.$parent.$broadcast('showModalJob', jobToEdit);
				};

				scope.showEditLeadModal = jobToEdit => {
					if (jobToEdit.startTime) {
						jobToEdit.startTime = timeConverter.convert24to12(
							jobToEdit.startTime
						);
						jobToEdit.finishTime = timeConverter.convert24to12(
							jobToEdit.finishTime
						);
					}

					$('#newLead').modal('show');

					scope.$parent.$broadcast('showModal', {
						lead: jobToEdit,
						jobId: scope.job.id
					});
				};

				scope.trueDate = '';
				scope.changeTaskStateForMainShoot = task => {};

				scope.isJobActive = task => {
					if (
						task.calendarEventType === 'MAIN_SHOOT' ||
						task.calendarEventType === 'EXTRA_SHOOT' ||
						task.calendarEventType === 'APPOINTMENT' ||
						task.name === 'Lead created'
					) {
						return false;
					} else if (
						task.mustDueDate !== null &&
						task.completed === false &&
						task.defaultTask === false &&
						task.calendarEvent === null
					) {
						scope.trueDate = task.mustDueDate;
						return true;
					} else if (
						task.completed &&
						task.calendarEventType === 'MAIN_SHOOT'
					) {
						return false;
					} else if (
						task.completed === true &&
						task.dueDate !== null &&
						task.hasDue === null
					) {
						scope.trueDate = task.dueDate;
						return true;
					} else if (
						(!task.completed && task.hasDue === false) ||
						task.hasDue === null
					) {
						return false;
					} else if (
						task.mustDueDate === null &&
						task.completed === false &&
						task.defaultTask === false
					) {
						if (task.taskViewDue.includes('main shoot')) {
							scope.trueDate = task.taskViewDue
								.replace('main shoot', scope.mainShootLabelName)
								.toLowerCase();
						} else {
							scope.trueDate = task.taskViewDue;
						}

						return true;
					} else if (
						task.hasDue === false ||
						task.hasDue === null ||
						(task.completed && task.calendarEvent === null)
					) {
						scope.trueDate = task.dueDate;
						return true;
					}
					return false;
				};
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/Workflow/workflowList.js